import Blue from "~/core";
import {
  computePosition,
  offset,
  shift,
  arrow
} from '@floating-ui/dom';
const libraryContent = document.querySelector('.video-library-search-content')
const classNames = {
  active: 'is-active',
  hidden: 'is-hidden',
  filtered: 'is-filtered'
}
new Blue({
  name: 'Video Library Filters',
  selector: ".js-video-filter",
  setup(filter) {
    const filters = filter.nextElementSibling
    const filtersInput = filter.querySelector('.video-library-search__input--filters')
    const filtersAnchor = filter.querySelector('.js-video-filter > i')
    const filtersArrow = filters.querySelector('.video-library-filters__arrow')
    const filtersCancel = filters.querySelector('.video-library-filters__cancel')
    const filtersReset = filters.querySelector('.video-library-filters__reset')
    const closeFilters = () => {filters.classList.toggle(classNames.active)}

    // variablizing the filter text to allow kentico control
    let filtersInputText = filtersInput.innerText

    //librarycontent datasets into array
    this.$addEvents(filter, 'click.prevent escape.stop.prevent', function () {
      closeFilters()
      // hack to make floating ui work properly
      window.process = {
        env: {
          NODE_ENV: 'production'
        }
      }
      // Anchoring filters
      computePosition(filtersAnchor, filters, {
        placement: 'bottom',
        middleware: [
          offset(35),
          // flip(),
          shift({
            padding: 5
          }),
          arrow({
            element: filtersArrow
          })
        ]
      }).then(({
        x,
        y,
        placement,
        middlewareData
      }) => {
        Object.assign(filters.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
        const {
          x: arrowX,
          y: arrowY
        } = middlewareData.arrow;
        const staticSide = {
          top: 'bottom',
          right: 'left',
          bottom: 'top',
          left: 'right',
        } [placement.split('-')[0]];

        Object.assign(filtersArrow.style, {
          left: arrowX != null ? `${arrowX}px` : '',
          top: arrowY != null ? `${arrowY}px` : '',
          right: '',
          bottom: '',
          [staticSide]: '-15px',
        });
      });
    })
    // Cancel button closes filters window
    this.$addEvents(filtersCancel, 'click.prevent escape.stop.prevent', function () {
      closeFilters()
    })

    // Reset Filters
    this.$addEvents(filtersReset, 'click', function () {
      activeReset()
      filtersInput.innerText = filtersInputText
    })

    this.$addEvents(filters, 'submit.prevent.stop', function (e) {
      closeFilters()
      new FormData(filters)
    })

    this.$addEvents(filters, 'formdata', function (e) {
      activeReset()
      const data = e.formData;      
      // check for formdata first
      // data.entries().next().value is the easiest way to see if a FormData object is empty
      if (data.entries().next().value) {
        filtersInput.innerText = ''
        let tags = []
        // Sets the wrapper to filtered
        if (!libraryContent.classList.contains(classNames.filtered)) {
          libraryContent.classList.add(classNames.filtered)
        }
        for (const value of data.values()) {
          const tagElement = `<span class="video-library-search__tag">${value.replaceAll(/-/ig, ' ').toLowerCase()}</span>`
          filtersInput.insertAdjacentHTML('afterbegin', tagElement)
          tags.push(value.toLowerCase())
        }
        for (let e of libraryContent.children) {
          let filters = {}
          if (e.dataset.filters) {
            filters = e.dataset.filters.toLowerCase().split('|')
          }
          
          // check for single filter first and that it matches
          if (filters.length == 1 && checkTags(tags, filters[0]) && !e.classList.contains(classNames.active)) {
            e.classList.add(classNames.active)
            if(e.classList.contains('video-library-search-content__item--individual')) {
              checkIndv(e,tags)
            }
          } else {
            // then run on multiple filters
            // using ordinary for loop so we can break out of it
            for (let i = 0; i < filters.length; i++) {
              const filter = filters[i]

              // if tag matches and its not filtered already
              if (checkTags(tags, filter) && !e.classList.contains(classNames.active)) {
                e.classList.add(classNames.active)
                // check individual videos
                if(e.classList.contains('video-library-search-content__item--individual')) {
                  checkIndv(e,tags)
                }
                
                // we're only concerned with the first matching tag so we break out
                break
              }
            }
          }
        }
      } else {
        // if we've got no formdata assume all content should be visible
        if (libraryContent.classList.contains(classNames.filtered)) {
          libraryContent.classList.remove(classNames.filtered)
        }
        for (let e of libraryContent.children) {
          e.classList.remove(classNames.active)
        }
        filtersInput.innerText = filtersInputText
      }

    })

  }
})

new Blue({
  name: 'Video Library Search',
  selector: ".video-library-search__input--search",
  setup(search) {
    // const videoTitles = libraryContent.querySelectorAll('.video-player__title')
    const videoPlayers = libraryContent.querySelectorAll('.video-player')
    this.$addEvents(search, 'input', function (e) {
      let textInput = this.value.toLowerCase()
      // add in timeouts?
      if (textInput.length > 2) {
        // library content titles == value
        // compare to substring based on input length
        videoPlayers.forEach(e => {
          // We want the surrounding container to hide
          const videoWrapper = e.parentElement.parentElement
          let videoTitle = e.querySelector('.video-player__title').innerText.toLowerCase()
          // compare text input to video titles
          // checking substring allows for real time filtering
          if (videoTitle.substring(0, textInput.length) !== textInput) {
            videoWrapper.classList.add(classNames.hidden)
          } else {
            videoWrapper.classList.remove(classNames.hidden)
          }
        })
      } else {
        // fall back to remove all hidden videos
        videoPlayers.forEach(e => {
          const videoWrapper = e.parentElement.parentElement
          if (videoWrapper.classList.contains(classNames.hidden)) {
            videoWrapper.classList.remove(classNames.hidden)
          }
        })
      }
    })
  }
});

// compares value to set of values in arrays
function checkTags(arr, val) {
  return arr.some((arrVal) => val === arrVal);
}
// check individual videos
function checkIndv(el, tags) {
  const videoPlayers = el.querySelectorAll('.video-player')
  el.classList.add(classNames.filtered)
  videoPlayers.forEach(e => {
    const wrapper = e.parentElement.parentElement
    let filters = {}
    if (e.dataset.filters) {
      filters = e.dataset.filters.toLowerCase().split('|')
    }
    // using ordinary for loop so we can break out of it
    for (let i = 0; i < filters.length; i++) {
      const filter = filters[i]
      wrapper.classList.remove(classNames.active)
      if(checkTags(tags,filter) && !wrapper.classList.contains(classNames.active)) {
        wrapper.classList.add(classNames.active)
        break
      }
    }
  });
}
function activeReset() {
  if (libraryContent.classList.contains(classNames.filtered)) {
    libraryContent.classList.remove(classNames.filtered)
  }
  for (let e of libraryContent.children) {
    e.classList.remove(classNames.active)
    if(e.classList.contains('video-library-search-content__item--individual')) {
      e.classList.remove(classNames.filtered)
      for (let player of e.children) {
        player.classList.remove(classNames.active)
      }
    }
  }
}